import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { getRoute } from '@common/constants/CampusRoutes';

import ReportPage from './layout';
import AboutPage from './layout/About';
import AchievementPage from './layout/Achievement';
import PortfolioPage from './layout/Achievement/Portfolio';

import GoalsPage from './layout/Goals';
import StrengthsPage from './layout/Strengths';
import IndividualityPage from './layout/Individuality';
import GoalsCreatePage from './layout/GoalsCreate';
import QualitiesPage from './layout/Qualities';
import InterestsPage from './layout/Interests';

function ReportRoute() {
	return (
		<Routes>
			<Route path="/" element={<ReportPage />}>
				<Route path="achievements" element={<AchievementPage />} />
				<Route path="achievements/portfolio" element={<PortfolioPage />} />
				<Route path="about" element={<AboutPage />} />
				<Route index element={<Navigate to={getRoute(['REPORT', 'ACHIEVEMENT'])} replace />} />
			</Route>
			<Route path={getRoute(['ABOUT', 'GOALS'])} element={<GoalsPage />} />
			<Route path={getRoute(['ABOUT', 'GOALS', 'CREATE'])} element={<GoalsCreatePage />} />
			<Route path={getRoute(['ABOUT', 'STEPS', 'CREATE'])} element={<GoalsCreatePage isSteps />} />
			<Route path={getRoute(['ABOUT', 'STRENGTHS'])} element={<StrengthsPage />} />
			<Route path={getRoute(['ABOUT', 'INDIVIDUALITY'])} element={<IndividualityPage />} />
			<Route path={getRoute(['ABOUT', 'INTERESTS'])} element={<InterestsPage />} />
			<Route path={getRoute(['ABOUT', 'QUALITIES'])} element={<QualitiesPage />} />
			<Route path="*" element={<Navigate to={getRoute(['REPORT', 'ACHIEVEMENT'])} replace />} />
		</Routes>
	);
}

export default ReportRoute;
